export default "__VITE_ASSET__ryrh$TiZ__"